import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  minus27abgkurcn6u0 as minus,
  plus18eogev54fmsa as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function nullToBlank(_this__u8e3s4) {
  var tmp = nullToBlank$lambda;
  return _this__u8e3s4.vak(tmp, nullToBlank$lambda_0);
}
function nullToBlank_0(_this__u8e3s4) {
  var tmp = nullToBlank$lambda_1;
  return _this__u8e3s4.vak(tmp, nullToBlank$lambda_2);
}
function equalTo(_this__u8e3s4, value) {
  var tmp = (it) => equals(it, value);
  return _this__u8e3s4.dak(tmp, (o, it) => it ? value : o);
}
function contains(_this__u8e3s4, value) {
  var tmp = (it) => it.t1(value);
  return _this__u8e3s4.dak(tmp, (items, bool) => bool ? plus(items, value) : minus(items, value));
}
function notNull(_this__u8e3s4, default_0) {
  var tmp = (it) => it == null ? default_0 : it;
  return _this__u8e3s4.vak(tmp, notNull$lambda);
}
function nullToBlank$lambda(it) {
  return it == null ? '' : it;
}
function nullToBlank$lambda_0(it) {
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!isBlank(it)) {
    tmp = it;
  } else {
    tmp = null;
  }
  return tmp;
}
function nullToBlank$lambda_1(it) {
  return it == null ? '' : it;
}
function nullToBlank$lambda_2(it) {
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!isBlank(it)) {
    tmp = it;
  } else {
    tmp = null;
  }
  return tmp;
}
function notNull$lambda(it) {
  return it;
}
//region block: exports
export {
  contains as contains3hkd7li7hrfjb,
  equalTo as equalTo2dio0vrcsd3je,
  notNull as notNull1cr24slx2d4vw,
  nullToBlank_0 as nullToBlank26aqgq3jx9stc,
  nullToBlank as nullToBlank2cwx9yazfqg5v,
};
//endregion

//# sourceMappingURL=commonLenses.mjs.map
